import styled from 'styled-components'

export const NoteItem = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.spacing.large};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  background: ${({ theme }) => theme.colors.background.primary};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.default};
    transform: translateY(-1px);
  }

  &:last-child {
    margin-bottom: 0;
  }
`

export const NoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.default};
`

export const NoteMeta = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

export const NoteAuthor = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
`

export const NoteSeparator = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
`

export const NoteTimestamp = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
`

export const NoteActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};

  button {
    color: ${({ theme }) => theme.colors.text.tertiary};
    transition: color ${({ theme }) => theme.transitions.fast};
  }

  ${NoteItem}:hover & button {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  @media (max-width: 768px) {
    button {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }

  button:focus {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`

export const NoteContent = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
  line-height: 1.6;

  p {
    margin: 0 0 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 8px 0;
    padding-left: 24px;
  }

  li {
    margin-bottom: 4px;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  blockquote {
    border-left: 3px solid ${({ theme }) => theme.colors.border.light};
    margin: 8px 0;
    padding-left: 16px;
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  code {
    background: ${({ theme }) => theme.colors.background.secondary};
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 13px;
  }

  pre {
    background: ${({ theme }) => theme.colors.background.secondary};
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 8px 0;

    code {
      background: transparent;
      padding: 0;
    }
  }

  mark {
    background-color: #ffeb3b;
    padding: 2px 4px;
    border-radius: 2px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 12px 0 8px;
    font-weight: 600;
  }

  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 18px;
  }
  h4 {
    font-size: 16px;
  }
  h5,
  h6 {
    font-size: 14px;
  }
`

export const DeleteConfirm = styled.div`
  position: absolute;
  top: 50px;
  right: 8px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.danger};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 10;
  min-width: 280px;
  animation: slideIn 0.2s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const DeleteText = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
  margin: 0 0 12px;
`

export const DeleteActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`
